module.exports = __webpack_public_path__ + "static/img/1044.da41d4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1044.jpg
// module id = 226
// module chunks = 0